import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_GLOBAL_UPDATES } from "authoring/lib/enum/authoring-feature-flags.mjs"

registerFeatureWithDescription({
    numericalId: 410,
    id: FEATURE_FLAG_GLOBAL_UPDATES,
    name: "Authoring Global Updates",
    internalUseOnly: true,
    readyForProduction: false,
    descriptionLines: ["Temporarily gates overwrite groups while Global Updates replace them."],
})

export { FEATURE_FLAG_GLOBAL_UPDATES }
